/**
 * Bản tiếng Anh của `#pm`. Mỗi chuỗi lấy từ `data-en` của chính node đó trong `template.html`.
 */

interface WbsRow {
  readonly code: string;
  readonly label: string;
  readonly percent: string;
  readonly level: 0 | 1;
  readonly tone: 'done' | 'running' | 'idle';
}

const wbsRows: readonly WbsRow[] = [
  { code: '1.0', label: 'Readiness', percent: '100%', level: 0, tone: 'done' },
  { code: '1.1', label: 'Infrastructure review', percent: '100%', level: 1, tone: 'done' },
  { code: '2.0', label: 'Rollout', percent: '62%', level: 0, tone: 'running' },
  { code: '2.1', label: 'Staged deploy', percent: '70%', level: 1, tone: 'running' },
  { code: '2.2', label: 'Customer comms', percent: '30%', level: 1, tone: 'idle' },
  { code: '3.0', label: 'Post-launch', percent: '0%', level: 0, tone: 'idle' },
];

export const pm = {
  eyebrow: 'Project Manager',
  heading: 'The team that talks about the work already owns the work.',
  lead: 'Start a project on any channel and pick the method that fits: time-boxed Sprints, continuous Kanban, or a hierarchical WBS. Switch later without losing tasks.',
  tabs: ['Sprint', 'Kanban', 'WBS'],
  sprint: {
    title: 'Sprint 14 · Atlas 4.0',
    status: 'RUNNING',
    /*
     * Thiết kế đặt mũi tên U+2192 giữa hai mốc ngày. Ở đây dùng `–` (en dash): lô 0 ĐO ĐƯỢC
     * rằng không `@font-face` nào trong bundle thiết kế phủ U+2192 và không file nguồn nào
     * có glyph cho nó (ghi trong `script/gen-fonts.mjs`), nên nó sẽ rơi về font hệ thống —
     * lệch nét ngay giữa một dòng chữ. `–` nằm trong subset `latin` và là dấu chuẩn cho
     * khoảng thời gian.
     */
    range: '02/07 – 16/07',
    progressStrong: '17/25',
    progressLabel: 'tasks completed · 6 days left',
    percent: 68,
    stats: [
      { value: '25', label: 'Committed' },
      { value: '3', label: 'Blockers open' },
      { value: '6', label: 'Assigned to me' },
      { value: '2', label: 'Awaiting review' },
    ],
    chips: ['Phase: Launch', 'Next: Sprint 15 (17/07)', 'Linked channel: #q2-launch'],
  },
  kanban: {
    columns: [
      { title: 'BACKLOG · 9', cards: ['Audit onboarding copy', 'Mobile push spec'] },
      { title: 'TO DO · 4', cards: ['Rollback runbook', 'QA sign-off sheet'] },
      { title: 'IN PROGRESS · 3', cards: ['Launch readiness report', 'Pricing page v2'] },
      { title: 'REVIEW · 2', cards: ['Migration script'] },
      { title: 'DONE · 11', cards: ['Design QA pass'] },
    ],
  },
  wbs: {
    title: 'WBS — Atlas 4.0 rollout',
    rows: wbsRows,
  },
};
